<template>
  <v-app>
    <sidebar v-if="loggedIn" v-model="drawer" />
    <navbar v-show="loggedIn" @toggle-sidebar="drawer = !drawer" />
    <v-content :class="loggedIn ? '' : 'bg'">
      <v-container>
        <router-view></router-view>
      </v-container>
      <snackbar></snackbar>
    </v-content>
  </v-app>
</template>

<script>
import { authComputed } from "@/vuex/helpers.js";
import Navbar from "@/components/common/TheNavbar";
import Sidebar from "@/components/common/TheSidebar";
import Snackbar from "@/components/common/TheSnackbar";

export default {
  name: "App",

  components: {
    Navbar,
    Sidebar,
    Snackbar
  },
  data() {
    return {
      drawer: null
    };
  },
  computed: {
    ...authComputed
  }
};
</script>
